import React, { Component } from 'react'
import { calendar, red_info } from '../../../assets/images';
import moment from 'moment'

const months = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April ',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December',
};

const monthsProps = {
  0: {
    name: 'January',
    shortName: 'Jan',
    CalendarMonthNumber: 1,
  },
  1: {
    name: 'February',
    shortName: 'Feb',
    CalendarMonthNumber: 2,
  },
  2: {
    name: 'March',
    shortName: 'Mar',
    CalendarMonthNumber: 3,
  },
  3: {
    name: 'April ',
    shortName: 'Apr',
    CalendarMonthNumber: 4,
  },
  4: {
    name: 'May ',
    shortName: 'May',
    CalendarMonthNumber: 5,
  },
  5: {
    name: 'June ',
    shortName: 'Jun',
    CalendarMonthNumber: 6,
  },
  6: {
    name: 'July',
    shortName: 'Jul',
    CalendarMonthNumber: 7,
  },
  7: {
    name: 'August',
    shortName: 'Agu',
    CalendarMonthNumber: 8,
  },
  8: {
    name: 'September',
    shortName: 'Sep',
    CalendarMonthNumber: 9,
  },
  9: {
    name: 'October',
    shortName: 'Oct',
    CalendarMonthNumber: 10,
  },
  10: {
    name: 'November ',
    shortName: 'Nov',
    CalendarMonthNumber: 11,
  },
  11: {
    name: 'December',
    shortName: 'Dec',
    CalendarMonthNumber: 12,
  },
};

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const daysProps = {
  0: {
    name: 'Sunday',
    shortName: 'Sun',
    CalendarWeekdayNumber: 6,
  },
  1: {
    name: 'Monday',
    shortName: 'Mon',
    CalendarWeekdayNumber: 0,
  },
  2: {
    name: 'Tuesday',
    shortName: 'Tue',
    CalendarWeekdayNumber: 1,
  },
  3: {
    name: 'Wednesday',
    shortName: 'Wed',
    CalendarWeekdayNumber: 2,
  },
  4: {
    name: 'Thursday',
    shortName: 'Thu',
    CalendarWeekdayNumber: 3,
  },
  5: {
    name: 'Friday',
    shortName: 'Fri',
    CalendarWeekdayNumber: 4,
  },
  6: {
    name: 'Saturday',
    shortName: 'Sat',
    CalendarWeekdayNumber: 5,
  },
};

class DateTimePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      date: '',
      displayDate: '',
      month: '',
      year: '',
      daysInMonthArr: [],
      blankDaysArr: [],
      day : (new Date).getDate(),
      hrCount : 0,
      minCount: 0,
      tagCount: 0
    };
  }
  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps, _) {
    if(prevProps.value !== this.props.value) this.init()
  }

  init = () => {
    const today = new Date();
    const month = this.props.value ? parseInt(moment(moment(this.props.value, 'DD-MM-YYYY - hh:mm a')).format('MM')) - 1 : today.getMonth();
    const year = this.props.value ? moment(moment(this.props.value, 'DD-MM-YYYY - hh:mm a')).format('YYYY') : today.getFullYear();

    const dayOfWeek = new Date(year, month).getDay();
    const Weekdays = daysProps[dayOfWeek].CalendarWeekdayNumber;
    // const displayDate = this.getDate(new Date(year, month, today.getDate()));
    const date = this.formatYearsMonthDay(new Date(year, month, today.getDate()));

    // Get last day number of the previous actual month
    const daysInMonth = new Date(year, month, 0).getDate();

    // Get the number (0-6) on which the actual month starts
    let blankDaysArr = [];
    for (let i = 1; i <= Weekdays; i++) {
      blankDaysArr.push(i);
    }

    let daysInMonthArr = [];
    for (let i = 1; i < daysInMonth; i++) {
      daysInMonthArr.push(i);
    }
    //setting date and time
    const day = moment(moment(this.props.value, 'DD-MM-YYYY - hh:mm a')).format('DD')
    const hour = moment(moment(this.props.value, 'DD-MM-YYYY - hh:mm a')).format('hh')
    const minute = moment(moment(this.props.value, 'DD-MM-YYYY - hh:mm a')).format('mm')
    const tag = this.props.value.includes("AM") ? 0 : 1

    this.setState({
      date,
      displayDate: this.props.value  ? this.props.value : '',
      month,
      year,
      daysInMonthArr,
      blankDaysArr,
      day: this.props.value ? day : (new Date).getDate(),
      hrCount : this.props.value ? parseInt(hour) - 1 : 0,
      minCount: this.props.value ? parseInt(minute) : 0,
      tagCount: this.props.value ? tag : 0
    }); 
}

  setDateTime = () => {
    const dateToFormat = this.state.day ? new Date(this.state.year, this.state.month, this.state.day) : '';
    const date = this.state.day ? this.formatYearsMonthDay(dateToFormat) : '';
    const displayDate = this.state.day ? `${this.getDate(dateToFormat)} - ${this.hours[this.state.hrCount]}:${this.minutes[this.state.minCount]} ${this.tags[this.state.tagCount]}` : '';

    this.props.handler(displayDate);
    this.setState((prevState, _) => ({
      ...prevState,
      date,
      displayDate,
      isOpen: false,
    }));
  };

  addMonth = () => {
    let newYear = '';
    let newMonth = '';
    if (this.state.month === 11) {
      newMonth = 0;
      newYear = this.state.year + 1;
    } else {
      newMonth = this.state.month + 1;
      newYear = this.state.year;
    }

    const newMonthFirstWeekdayNumber = new Date(newYear, newMonth, 1).getDay();
    const firstWeekdayNumber = daysProps[newMonthFirstWeekdayNumber].CalendarWeekdayNumber;
    const daysInMonth = new Date(newYear, newMonth + 1, 0).getDate();

    let blankDaysArr = [];
    for (let i = 1; i <= firstWeekdayNumber; i++) {
      blankDaysArr.push(i);
    }

    let daysInMonthArr = [];
    for (let i = 1; i <= daysInMonth; i++) {
      daysInMonthArr.push(i);
    }

    this.setState((prevState, _) => {
      return {
        ...prevState,
        month: newMonth,
        year: newYear,
        daysInMonthArr,
        blankDaysArr,
        day : 0
      };
    });
  };

  subtractMonth = () => {
    let newYear = '';
    let newMonth = '';
    if (this.state.month === 0) {
      newMonth = 11;
      newYear = this.state.year - 1;
    } else {
      newMonth = this.state.month - 1;
      newYear = this.state.year;
    }

    const newMonthFirstWeekdayNumber = new Date(newYear, newMonth, 1).getDay();
    const firstWeekdayNumber = daysProps[newMonthFirstWeekdayNumber].CalendarWeekdayNumber;
    const daysInMonth = new Date(newYear, newMonth + 1, 0).getDate();

    let blankDaysArr = [];
    for (let i = 1; i <= firstWeekdayNumber; i++) {
      blankDaysArr.push(i);
    }

    let daysInMonthArr = [];
    for (let i = 1; i <= daysInMonth; i++) {
      daysInMonthArr.push(i);
    }
    this.setState((prevState, _) => {
      return {
        ...prevState,
        month: newMonth,
        year: newYear,
        daysInMonthArr,
        blankDaysArr,
        day : 0
      };
    });
  };

  getDate = (date) => {
    const year = date.getFullYear();
    const monthNumber = monthsProps[date.getMonth()].CalendarMonthNumber;
    const month = ('0' + monthNumber).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${day}-${month}-${year}`;
  };

  formatYearsMonthDay = (date) => {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  };

  isDateSelected = (dayNumber) => {
    if(!dayNumber) return false

    const day = new Date(this.state.year, this.state.month, dayNumber);
    const selectedDate = this.state.day ? new Date(this.state.year, this.state.month, this.state.day) : new Date();

    return selectedDate.toDateString() === day.toDateString() ? true : false;
  }

  toggleDatePanel = () => {
    this.setState((prevState, _) => {
      return {
        ...prevState,
        isOpen: !prevState.isOpen,
      };
    });
  };

  hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) =>{
    return item.toString().padStart(2, '0')
  })
  minutes = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59].map((item) =>{
    return item.toString().padStart(2, '0')
  })
  tags = ['AM', 'PM']
  toggleDisplayDateFocus = () => {
    /**
     * This functions triggers when the user clicks:
     * 1. The input element
     * 2. The input element goes out of focus
     * 3. A day in the calendar
     *
     * When the calendar input contains shadow-outline class it means it's focus,
     * so we remove that class and trigger blur programatically.
     * On the other hand if the input doesn't have the class, it means it's not focused,
     * so we trigger the focus and add the class.
     */
    const displayDate = document.getElementById('displayDateRef');
    if (displayDate.classList.contains('shadow-outline')) {
      displayDate.classList.remove('shadow-outline');
      displayDate.blur();
    } else {
      displayDate.classList.add('shadow-outline');
      displayDate.focus();
    }

    const daysDiv = document.getElementById('daysDivRef');
    daysDiv.focus();
  };
  
  ShowTheDate =(e) =>{
    let {name,value} = e
    let newState ={...this.state}
    newState = {...newState, displayDate : value}
    this.setState({...newState}) 
  }

  FixTheDate = () =>{
    let displayDate = this.state.displayDate
    let aDate =  moment(displayDate.toLowerCase(),'DD-MM-YYYY - hh:mm a',true)
    var isValid = aDate.isValid();
    if(isValid) {
      const today = new Date();
      const month =  parseInt(moment(moment(displayDate.toLowerCase(), 'DD-MM-YYYY - hh:mm a')).format('MM')) - 1
      const year =  moment(moment(displayDate.toLowerCase(), 'DD-MM-YYYY - hh:mm a')).format('YYYY')

      const dayOfWeek = new Date(year, month).getDay();
      const Weekdays = daysProps[dayOfWeek].CalendarWeekdayNumber;
      // const displayDate = this.getDate(new Date(year, month, today.getDate()));
      const date = this.formatYearsMonthDay(new Date(year, month, today.getDate()));

      // Get last day number of the previous actual month
      const daysInMonth = new Date(year, month, 0).getDate();

      // Get the number (0-6) on which the actual month starts
      let blankDaysArr = [];
      for (let i = 1; i <= Weekdays; i++) {
        blankDaysArr.push(i);
      }

      let daysInMonthArr = [];
      for (let i = 1; i < daysInMonth; i++) {
        daysInMonthArr.push(i);
      }
      //setting date and time
      const day = moment(moment(displayDate.toLowerCase(), 'DD-MM-YYYY - hh:mm a')).format('DD')
      const hour = moment(moment(displayDate.toLowerCase(), 'DD-MM-YYYY - hh:mm a')).format('hh')
      const minute = moment(moment(displayDate.toLowerCase(), 'DD-MM-YYYY - hh:mm a')).format('mm')
      const tag = displayDate.includes("AM" || 'am') ? 0 : 1

      this.setState({
        date,
        displayDate: displayDate,
        month,
        year,
        daysInMonthArr,
        blankDaysArr,
        day: displayDate ? day : (new Date).getDate(),
        hrCount : displayDate ? parseInt(hour) - 1 : 0,
        minCount: displayDate ? parseInt(minute) : 0,
        tagCount: displayDate ? tag : 0
      }); 

      this.props.handler(displayDate)
    }
  }

  render() {
    let width = this.props.width ? this.props.width :  '40rem'
    return (
      <span className='relative'>
        {this.props.label && <p className={'block mb-2' + this.props.labelClasses} style={{color : this.props.color, fontSize : this.props.size}}>{this.props.label}</p>}
        <div id='displayDateRef' className='relative'>
          <div className={`absolute content-center text-center left-3 cursor-pointer ${this.props.classes}`}>
            <img src={calendar} style={{ width: 14 }} alt='calender' />
          </div>
          <input
            type='text'
            value={this.state.displayDate}
            name={this.props.inputName}
            onClick={() => {
              this.toggleDatePanel();
            }}
            onChange={(e) => this.ShowTheDate(e.target)}
            disabled={this.props.disabled}
            onBlur={() => {
             this.setState({ isOpen: false })
             this.FixTheDate() }}
            className={`placeholder-gray-300 pl-9 border border-gray-200 font-semibold text-base rounded-md  focus:ring-blue-500 ${ this.props.disabled ? 'font-semibold text-base leading-4 w-full h-14 bg-gray-100 cursor-not-allowed text-gray-300' :  this.props.inputClasses}`}
            placeholder='DD-MM-YYYY - HH:MM'
          />
          {this.props.error && <p className='mb-0 text-red-600 flex flex-row'><img src={red_info} className='mr-2'/>{this.props.error}</p>}
        </div>
        <div
          className={`focus:outline-none duration-200 bg-white rounded-lg w-full shadow p-4 absolute  ${
            !this.state.isOpen ? 'hidden opacity-0' : 'opacity-100'
          }`}
          style={{ width: width, zIndex:1000 }}
          id='daysDivRef'
          tabIndex={-1}
        >
          <div className='flex flex-row'>
            <div className='w-1/2 border-r border-gray-200 pr-1'>
               <div className='flex justify-between mb-2'>
                 <button
                    type='button'
                    className='transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full focus:shadow-outline focus:outline-none mr-1'
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={this.subtractMonth}
                  >
                    <svg
                      className='h-6 w-6 text-gray-500 inline-flex'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                    >
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M15 19l-7-7 7-7' />
                    </svg>
                  </button>
                  <div className='mt-1'>
                      <span className='text-lg tracking-wider .font-semibold text-gray-800'>{months[this.state.month]?.toUpperCase()} {this.state.year}</span>
                    </div>
                  <div>
                
                  <button
                    type='button'
                    onMouseDown={(event) => event.preventDefault()}
                    className='transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full focus:shadow-outline focus:outline-none'
                    onClick={this.addMonth}
                  >
                    <svg
                      className='h-6 w-6 text-gray-500 inline-flex'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                    >
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M9 5l7 7-7 7' />
                    </svg>
                  </button>
                </div>
              </div>
              <div className='flex flex-wrap mb-3 -mx-1 '>
                {days.map((day, index) => (
                  <div key={index} style={{ width: '14.26%' }} className='px-1'>
                    <div className='text-gray-800 font-semibold text-center text-xs'>{day}</div>
                  </div>
                ))}
              </div>

              <div className='flex flex-wrap -mx-1 '>
                {this.state.blankDaysArr.map((day) => (
                  <div key={day} style={{ width: '14.28%' }} className='text-center  p-1 border-transparent text-sm' />
                ))}
                {this.state.daysInMonthArr.map((dayNumber, index) => (
                  <div key={index} style={{ width: '14.28%' }} className='px-1 mb-1'>
                    <div
                      onClick={() => this.setState({day: dayNumber})}
                      onMouseDown={(event) => event.preventDefault()}
                      className={`cursor-pointer text-center text-sm rounded-full leading-loose font-semibold transition ease-in-out duration-100 
                                  ${
                                    this.isDateSelected(dayNumber)
                                      ? 'bg-blue-500 text-white'
                                      : 'text-gray-400 hover:bg-blue-200'
                                  }`}
                    >
                      {dayNumber}
                    </div>
                  </div>
                ))}
              </div> 
            </div>
            <div className='w-1/2 flex flex-row text-center items-center' onMouseDown={(event) => event.preventDefault()}>
              <div className='grid grid-cols-4 gap4 cursor-pointer px-6'>
                <div className='flex flex-col align-middle relative  h-full'>
                  <p className='text-sm font-semibold leading-4 text-gray-400 h-4 mb-2 ' onClick={() =>this.setState({hrCount : (this.state.hrCount <= 1  ? 2 : this.state.hrCount) - 2})}>{this.hours[this.state.hrCount - 2]}</p>
                  <p 
                    onClick={(element) => {
                      this.setState({hrCount : (this.state.hrCount <= 0  ? 1 : this.state.hrCount) - 1})} }
                    className='text-base h-4 font-semibold leading-4 text-gray-400'
                  > 
                    {this.hours[this.state.hrCount - 1]} 
                  </p>
                  <p className='rounded-md font-semibold text-xl text-white bg-blue-600 py-1 px-2 my-2' id='1'>{this.hours[this.state.hrCount]}</p>        
                  <p onClick={() => this.setState({hrCount : (this.state.hrCount > 10  ?  10 : this.state.hrCount) + 1})}  className='text-base h-4 font-semibold leading-4 text-gray-400'>{this.hours[this.state.hrCount + 1]}</p>
                  <p onClick={() => this.setState({hrCount : (this.state.hrCount > 8  ?  8 : this.state.hrCount) + 2})} className='text-sm font-semibold leading-4 text-gray-400 h-4 mt-2'>{this.hours[this.state.hrCount + 2]}</p>
                </div>
                <p className=' font-semibold text-3xl text-gray-700 align middle' style={{marginTop : '50px'}} >:</p>
                <div className='flex flex-col align-middle'>
                  <p onClick={() => this.setState({minCount : (this.state.minCount <= 1  ? 2 : this.state.minCount)  - 2})} className='text-sm font-semibold leading-4 text-gray-400 h-4 mb-2'>{this.minutes[this.state.minCount - 2]}</p>
                  <p onClick={() => this.setState({minCount : (this.state.minCount <= 0  ? 1 : this.state.minCount)  - 1})} className='text-base h-4 font-semibold leading-4 text-gray-400'> {this.minutes[this.state.minCount - 1]} </p>                  
                  <p className='rounded-md font-semibold  text-xl text-white bg-blue-600 py-1 px-2 my-2' >{this.minutes[this.state.minCount]}</p>
                  <p onClick={() => this.setState({minCount : (this.state.minCount > 58  ?  58 : this.state.minCount) + 1})} className='text-base h-4 font-semibold leading-4 text-gray-400'>{this.minutes[this.state.minCount + 1]}</p>
                  <p onClick={() => this.setState({minCount : (this.state.minCount > 57  ?  57 : this.state.minCount) + 2})} className='text-sm font-semibold leading-4 text-gray-400 h-4 mt-2'>{this.minutes[this.state.minCount + 2]}</p>
                </div>
                <div className='flex flex-col' style={{paddingTop : '50px'}}>
                  <p className='text-blue-600 pl-6 font-semibold rounded-md text-xl mb-0' >{this.tags[this.state.tagCount === 0 ? 0 : 1]}</p>
                  <p className='rounded-md font-semibold pl-6 text-gray-900 text-xl mt-0' onClick={() =>{(this.state.tagCount === 0) ? this.setState({tagCount : 1}) : this.setState({tagCount : 0})}}>{this.tags[this.state.tagCount === 0 ? 1 : 0]}</p>
                </div>
                <div className='justify-end absolute bottom-8 right-12'>
                  <button className='text-white rounded-md py-2 px-4 bg-blue-600 text-sm font-semibold' onClick={this.setDateTime}>Done</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

DateTimePicker.defaultProps = {
  handler: () => {},
  value: '',
  inputClasses: 'text-gray-700 bg-gray-100 focus:bg-gray-100 p-4 pr-6',
  inputName: '',
  error: ''
}


export default DateTimePicker;




